export class InvestmentApplicationFlowStep {
    public displayName: string;
    public description: string;
    public url: string;
    public showWelcomePageOnLeftPane: boolean;
    public previousLink: string;
    public nextLink: string;
    public isOptional: boolean;
    public changed = false;
    public isComplete = false;

    constructor(displayName: string, description: string, url: string,
                previousLink?: string, nextLink?: string, isOptional?: boolean, showWelcomePageOnLeftPane?: boolean) {
        this.displayName = displayName;
        this.description = description;
        this.url = url;
        this.showWelcomePageOnLeftPane = showWelcomePageOnLeftPane;
        this.previousLink = previousLink;
        this.nextLink = nextLink;
        this.isOptional = isOptional;
    }
}
